export default __webpack_public_path__ + "static/media/status-pending.8defc8cd.svg";